import { createMuiTheme } from "@material-ui/core";

export const theme = createMuiTheme({
    palette: {
        background: {
            default: '#fcf7c4',
        },
        primary: {
            main: '#112A46',
        },
        secondary: {
            main: '#ffdbdb',
        },
    },
    typography: {
        fontFamily: [
            '"Noto Sans TC"',
            // '-apple-system',
            // 'BlinkMacSystemFont',
            // '"Segoe UI"',
            // 'Roboto',
            // '"Helvetica Neue"',
            // 'Arial',
            // 'sans-serif',
            // '"Apple Color Emoji"',
            // '"Segoe UI Emoji"',
            // '"Segoe UI Symbol"',
        ].join(','),
    }
});